// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url('https://fonts.googleapis.com/css?family=Muli:400,700');*/

*, *:before, *:after {
  box-sizing: border-box;
}  


.main .mapa {
    margin-top: 67px;
}
.navbar.navbar-transparent {
    padding-top: 15px ;
}
#map {
  width: 100% !important;
  height: 500px !important;
  position: relative;
  overflow: hidden;
}

@media only screen and (min-width: 768px) {
  #map {
    height: 100% !important;
    flex: 1 1;
  }
}

a {
  text-decoration: none;
}

.address-list-wrap {
  width: 100%;
  height: auto;
  z-index: 1;
  background: #e6e6e6;
}

@media only screen and (min-width: 768px) {
  .address-list-wrap {
    width: 300px;
    height: 100%;
    
  }
}

.list-wrap {
  height: 250px;
  overflow-y: scroll;
}

@media only screen and (min-width: 768px) {
  .list-wrap {
    height: calc(100% - 40px);
    overflow-y: scroll;
  }
}

@media only screen and (min-width: 768px) {
  .flex {
    display: flex;
  }
}

.wrapper {
  /*background: #b3dfff;*/
  height: 100%;
}

@media only screen and (min-width: 768px) {
  .wrapper {
    height: calc(100vh - 70px);
  }
}

.filter-wrap {
  background: #e2e1e1;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  /* justify-content: center;
  flex-direction: column; */
  justify-content: initial;
  flex-direction: row;
}

.filter-wrap > div {
  width: auto;
  margin-bottom: 5px;
}
.filter-wrap > div:not(:last-child){
  margin-right: 10px;
}

.filter-wrap > div:last-child {
  margin-bottom: 0;
}

@media only screen and (min-width: 768px) {
  .filter-wrap > div {
    width: auto;
    margin-bottom: 0;
  }

  .filter-wrap {
    justify-content: initial;
    flex-direction: row;
  }
}

#addressInput, #resetButton {
  padding: 8px 16px;
  margin: 0;
  outline: none;
  font-size: 14px;
  background: transparent;
  height: 40px;
  font-weight: 400;
  border-radius: 2px;
}

#addressInput {
  border: 1px solid #ccc;
  background: #fff;
  width: 240px;
}

@media only screen and (min-width: 768px) {
  #addressInput {
    width: 400px;
  }
}

#resetButton {
  background: #5167A6;
  padding: 5px 15px;
  color: #ffffff;
  border-color: transparent;
  cursor: pointer;
}

#resetButton:hover {
  background: #303c61;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-wrap {
  padding: 0;
  margin: 0;
}

.name {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 5px;
}



.list-marker{
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease-in-out;
}
.list-marker:hover{
  background: #f1f5ff;
  transition: all 0.3s ease-in-out;
}

.list-details {
  padding: 15px;
}

.list-marker .list-content > div {
  font-size: 14px;
  line-height: 20px; 
  color: #000;
}

.list-marker .list-content > div:last-child {
  margin-bottom: 0;
}

.list-marker:not(:first-child) {
  border-top: 1px solid #d0cfcf;
}

.list-marker a {
  display: inline-block;
  color: #2f52b8;
}

.marker-detail {
  font-weight: 400;
}

.marker-detail .title {
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 5px;
}

.marker-detail .city {
  display: block;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 10px;
}

.marker-detail .address {
  display: block;
  margin-bottom: 5px;
}

.marker-detail .tel {
  display: block;
  margin-bottom: 5px;
}

.marker-detail .time {
  display: block;
  margin-bottom: 5px;
}

.marker-detail .direction {
  display: inline-block;
}

.marker-detail a {
  text-decoration: none;
  display: inline-block;
  margin-bottom: 5px;
}

.spinner {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  position: relative;
  top: 50px;
  border: 3px solid rgb(190, 190, 190);
  border-top-color: #5167A6;
  border-radius: 50%;
  animation: rotation .8s ease infinite;
}
.markerLatitude { display:none; }
.radius-select, .city-select, .type-select, .day-select{
  position: relative;
  display: inline-block;
}

.select__arrow {
  position: absolute;
  top: 18px;
  right: 15px;
  width: 0;
  height: 0;
  pointer-events: none;
  border-style: solid;
  border-width: 6px 4px 0 4px;
  border-color: #5167A6 transparent transparent transparent;
}

#radiusSelect, #citySelect, #typeSelect, #daySelect {
  font-size: 14px;
  height: 40px;
  display: inline-block;
  font-weight: 400;
  padding: 5px 30px 10px 15px;
  cursor: pointer;
  outline: 0;
  border: 0;
  border-radius: 2px;
  background: #fff;
  color: #333333;
  border: 1px solid #ccc;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
}

@media only screen and (min-width: 768px) {
  #radiusSelect {
    width: auto;
  }
}

label {
  display: block;
  margin-bottom: 4px;
  font-weight: 700;
  font-size: 14px;
  color: #5b72af;
}
#header-area {
  height: auto;
  background-color: #01204c;
}
#header-area .z-index {
  margin-top: 0px;
}
.navbar-brand img {
  margin-top: -8px;
}
.mapa p, h2, input, .MuiSelect-outlined.MuiSelect-outlined{
  color: #000 !important;
}
.gm-style-iw-d h4{
 color: red;
}`, "",{"version":3,"sources":["webpack://./src/assets/adicional/map.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,sBAAsB;AACxB;;;AAGA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,SAAO;EACT;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;;EAEd;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB;2BACyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;AAYA,kBAAkB,YAAY,EAAE;AAChC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;CACC,UAAU;AACX","sourcesContent":["/*@import url('https://fonts.googleapis.com/css?family=Muli:400,700');*/\n\n*, *:before, *:after {\n  box-sizing: border-box;\n}  \n\n\n.main .mapa {\n    margin-top: 67px;\n}\n.navbar.navbar-transparent {\n    padding-top: 15px ;\n}\n#map {\n  width: 100% !important;\n  height: 500px !important;\n  position: relative;\n  overflow: hidden;\n}\n\n@media only screen and (min-width: 768px) {\n  #map {\n    height: 100% !important;\n    flex: 1;\n  }\n}\n\na {\n  text-decoration: none;\n}\n\n.address-list-wrap {\n  width: 100%;\n  height: auto;\n  z-index: 1;\n  background: #e6e6e6;\n}\n\n@media only screen and (min-width: 768px) {\n  .address-list-wrap {\n    width: 300px;\n    height: 100%;\n    \n  }\n}\n\n.list-wrap {\n  height: 250px;\n  overflow-y: scroll;\n}\n\n@media only screen and (min-width: 768px) {\n  .list-wrap {\n    height: calc(100% - 40px);\n    overflow-y: scroll;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .flex {\n    display: flex;\n  }\n}\n\n.wrapper {\n  /*background: #b3dfff;*/\n  height: 100%;\n}\n\n@media only screen and (min-width: 768px) {\n  .wrapper {\n    height: calc(100vh - 70px);\n  }\n}\n\n.filter-wrap {\n  background: #e2e1e1;\n  padding: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  /* justify-content: center;\n  flex-direction: column; */\n  justify-content: initial;\n  flex-direction: row;\n}\n\n.filter-wrap > div {\n  width: auto;\n  margin-bottom: 5px;\n}\n.filter-wrap > div:not(:last-child){\n  margin-right: 10px;\n}\n\n.filter-wrap > div:last-child {\n  margin-bottom: 0;\n}\n\n@media only screen and (min-width: 768px) {\n  .filter-wrap > div {\n    width: auto;\n    margin-bottom: 0;\n  }\n\n  .filter-wrap {\n    justify-content: initial;\n    flex-direction: row;\n  }\n}\n\n#addressInput, #resetButton {\n  padding: 8px 16px;\n  margin: 0;\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n  height: 40px;\n  font-weight: 400;\n  border-radius: 2px;\n}\n\n#addressInput {\n  border: 1px solid #ccc;\n  background: #fff;\n  width: 240px;\n}\n\n@media only screen and (min-width: 768px) {\n  #addressInput {\n    width: 400px;\n  }\n}\n\n#resetButton {\n  background: #5167A6;\n  padding: 5px 15px;\n  color: #ffffff;\n  border-color: transparent;\n  cursor: pointer;\n}\n\n#resetButton:hover {\n  background: #303c61;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.list-wrap {\n  padding: 0;\n  margin: 0;\n}\n\n.name {\n  font-size: 15px;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n\n\n.list-marker{\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.3s ease-in-out;\n}\n.list-marker:hover{\n  background: #f1f5ff;\n  transition: all 0.3s ease-in-out;\n}\n\n.list-details {\n  padding: 15px;\n}\n\n.list-marker .list-content > div {\n  font-size: 14px;\n  line-height: 20px; \n  color: #000;\n}\n\n.list-marker .list-content > div:last-child {\n  margin-bottom: 0;\n}\n\n.list-marker:not(:first-child) {\n  border-top: 1px solid #d0cfcf;\n}\n\n.list-marker a {\n  display: inline-block;\n  color: #2f52b8;\n}\n\n.marker-detail {\n  font-weight: 400;\n}\n\n.marker-detail .title {\n  font-size: 15px;\n  font-weight: bold;\n  margin: 0 0 5px;\n}\n\n.marker-detail .city {\n  display: block;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 10px;\n}\n\n.marker-detail .address {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.marker-detail .tel {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.marker-detail .time {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.marker-detail .direction {\n  display: inline-block;\n}\n\n.marker-detail a {\n  text-decoration: none;\n  display: inline-block;\n  margin-bottom: 5px;\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  margin: 0 auto;\n  position: relative;\n  top: 50px;\n  border: 3px solid rgb(190, 190, 190);\n  border-top-color: #5167A6;\n  border-radius: 50%;\n  animation: rotation .8s ease infinite;\n}\n\n@-webkit-keyframes rotation {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.markerLatitude { display:none; }\n.radius-select, .city-select, .type-select, .day-select{\n  position: relative;\n  display: inline-block;\n}\n\n.select__arrow {\n  position: absolute;\n  top: 18px;\n  right: 15px;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n  border-style: solid;\n  border-width: 6px 4px 0 4px;\n  border-color: #5167A6 transparent transparent transparent;\n}\n\n#radiusSelect, #citySelect, #typeSelect, #daySelect {\n  font-size: 14px;\n  height: 40px;\n  display: inline-block;\n  font-weight: 400;\n  padding: 5px 30px 10px 15px;\n  cursor: pointer;\n  outline: 0;\n  border: 0;\n  border-radius: 2px;\n  background: #fff;\n  color: #333333;\n  border: 1px solid #ccc;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 100%;\n}\n\n@media only screen and (min-width: 768px) {\n  #radiusSelect {\n    width: auto;\n  }\n}\n\nlabel {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 700;\n  font-size: 14px;\n  color: #5b72af;\n}\n#header-area {\n  height: auto;\n  background-color: #01204c;\n}\n#header-area .z-index {\n  margin-top: 0px;\n}\n.navbar-brand img {\n  margin-top: -8px;\n}\n.mapa p, h2, input, .MuiSelect-outlined.MuiSelect-outlined{\n  color: #000 !important;\n}\n.gm-style-iw-d h4{\n color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
